[
  {
    "key": "homepage",
    "route": "/",
    "content": {
      "page": "/",
      "meta": {
        "title": "Дизайн, фото и презентации в Canva",
        "description": "Выберите задачу: создать дизайн, собрать презентацию, сгенерировать изображение или обработать фото в Canva. Независимый русскоязычный путеводитель.",
        "h1": "Создавайте дизайн без сложных программ",
        "ogTitle": "Дизайн, фото и презентации в Canva",
        "ogDescription": "Выберите задачу: создать дизайн, собрать презентацию, сгенерировать изображение или обработать фото в Canva. Независимый русскоязычный путеводитель."
      },
      "sections": {
        "hero": {
          "eyebrow": "Независимый русскоязычный проект",
          "h1": "Создавайте дизайн без сложных программ",
          "subtitle": "Выберите задачу, посмотрите результат и перейдите к подходящему инструменту Canva.",
          "primaryCta": "Попробовать бесплатно",
          "secondaryCta": ""
        },
        "capabilities": {
          "h2": "Что хотите сделать?",
          "cards": [
            {
              "id": "capability-1",
              "title": "Собрать презентацию",
              "description": "Превратите тему или черновик в последовательность слайдов и доработайте содержание."
            },
            {
              "id": "capability-2",
              "title": "Создать изображение",
              "description": "Опишите сцену и получите визуальное направление для дальнейшего редактирования."
            },
            {
              "id": "capability-3",
              "title": "Обработать фотографию",
              "description": "Настройте кадр, цвет, фон и отдельные объекты в одном рабочем процессе."
            },
            {
              "id": "capability-4",
              "title": "Подготовить публикацию",
              "description": "Адаптируйте макет под пост, историю, афишу или карточку товара."
            },
            {
              "id": "capability-5",
              "title": "Объединить материалы",
              "description": "Соберите несколько изображений и текстовых элементов в цельную композицию."
            }
          ]
        },
        "workflow": {
          "h2": "Как получить контролируемый результат",
          "steps": [
            {
              "index": 1,
              "title": "Выберите задачу",
              "description": "Определите, какой результат нужен сейчас."
            },
            {
              "index": 2,
              "title": "Добавьте исходные данные",
              "description": "Введите описание или загрузите собственный материал."
            },
            {
              "index": 3,
              "title": "Доработайте макет",
              "description": "Проверьте композицию, текст, формат и детали перед экспортом."
            }
          ]
        },
        "useCases": {
          "h2": "Для каких задач подходит",
          "items": [
            {
              "title": "Для работы",
              "description": "Презентации, документы и визуальные пояснения."
            },
            {
              "title": "Для соцсетей",
              "description": "Посты, истории, обложки и рекламные материалы."
            },
            {
              "title": "Для продаж",
              "description": "Карточки товаров, баннеры и коммерческие макеты."
            },
            {
              "title": "Для личных проектов",
              "description": "Приглашения, коллажи и обработка фотографий."
            }
          ]
        },
        "benefits": {
          "h2": "Почему такой порядок работает",
          "items": [
            {
              "title": "Понятный старт",
              "description": "Сначала выбираете результат, затем конкретный инструмент."
            },
            {
              "title": "Связанный процесс",
              "description": "После одной операции легко перейти к следующей задаче."
            },
            {
              "title": "Редактируемый итог",
              "description": "Результат можно проверять и дорабатывать перед публикацией."
            }
          ]
        },
        "limits": {
          "h2": "Что проверить перед началом",
          "body": "Доступность конкретных функций, режимов, лимитов и вариантов экспорта может меняться. Проверяйте актуальные условия в своём аккаунте и на официальном сайте Canva."
        },
        "related": {
          "h2": "Связанные задачи",
          "links": [
            {
              "route": "/sozdat-dizajn/",
              "anchor": "Создайте дизайн под конкретный формат"
            },
            {
              "route": "/redaktor-foto/",
              "anchor": "Редактируйте фото в одном рабочем пространстве"
            },
            {
              "route": "/nejroset-dlya-prezentacij/",
              "anchor": "Создайте презентацию из темы с помощью ИИ"
            },
            {
              "route": "/generator-izobrazhenij/",
              "anchor": "Генератор изображений по текстовому запросу"
            }
          ]
        },
        "faq": {
          "h2": "Частые вопросы",
          "items": [
            {
              "question": "Что можно создать с помощью Canva?",
              "answer": "Презентации, изображения, материалы для соцсетей, документы и другие визуальные форматы. Доступность конкретных функций нужно проверять в своём аккаунте Canva."
            },
            {
              "question": "Этот сайт является официальным сайтом Canva?",
              "answer": "Нет. Это независимый русскоязычный проект, который помогает выбрать сценарий и перейти к нужному инструменту."
            },
            {
              "question": "С чего лучше начать?",
              "answer": "Сформулируйте результат: презентация, новое изображение, обработанное фото или готовый дизайн под определённый формат."
            },
            {
              "question": "Можно ли сначала посмотреть пример результата?",
              "answer": "Да. Страницы проекта показывают действие, ожидаемый результат и связанные инструменты."
            },
            {
              "question": "Нужно ли устанавливать сложную программу?",
              "answer": "Путеводитель ориентирован на браузерные сценарии. Условия работы конкретного инструмента уточняйте на официальном сайте Canva."
            }
          ]
        },
        "finalCta": {
          "h2": "Перейдите к нужному результату",
          "description": "Выберите подходящий сценарий, проверьте исходные материалы и начните работу в Canva.",
          "primaryCta": "Попробовать бесплатно"
        }
      }
    },
    "images": [
      {
        "assetId": "homepage-visual-01",
        "section": "hero",
        "action": "KEEP_EXISTING",
        "purpose": "рука собирает презентацию, пост и фотомакет в единую композицию",
        "src": "/assets/hero-creative-flow.webp"
      },
      {
        "assetId": "homepage-visual-02",
        "section": "product-proof",
        "action": "KEEP_EXISTING",
        "purpose": "мозаика разных готовых форматов",
        "src": "/assets/results-gallery.webp"
      },
      {
        "assetId": "homepage-visual-03",
        "section": "examples",
        "action": "KEEP_EXISTING",
        "purpose": "путь от задачи к редактируемому результату",
        "src": "/assets/before-after-background.webp"
      }
    ]
  },
  {
    "key": "dobavit-udalit-obekt-na-foto",
    "route": "/dobavit-udalit-obekt-na-foto/",
    "content": {
      "page": "/dobavit-udalit-obekt-na-foto/",
      "meta": {
        "title": "Добавить или удалить объект на фото",
        "description": "Как локально изменить фото в Canva: выделить область, убрать лишний предмет или добавить новый объект и проверить естественность результата.",
        "h1": "Добавьте или удалите объект на фото",
        "ogTitle": "Добавить или удалить объект на фото",
        "ogDescription": "Как локально изменить фото в Canva: выделить область, убрать лишний предмет или добавить новый объект и проверить естественность результата."
      },
      "sections": {
        "hero": {
          "eyebrow": "Практический сценарий",
          "h1": "Добавьте или удалите объект на фото",
          "subtitle": "Измените выбранную область кадра, сохранив композицию, свет и узнаваемые детали остальной сцены.",
          "primaryCta": "Попробовать бесплатно",
          "secondaryCta": ""
        },
        "capabilities": {
          "h2": "Что входит в этот сценарий",
          "cards": [
            {
              "id": "capability-1",
              "title": "Точная область изменения",
              "description": "Выделяйте только предмет и небольшой контекст вокруг него."
            },
            {
              "id": "capability-2",
              "title": "Удаление помехи",
              "description": "Восстановите фон так, чтобы текстуры и линии продолжались естественно."
            },
            {
              "id": "capability-3",
              "title": "Добавление элемента",
              "description": "Опишите объект, материал, размер и положение в сцене."
            },
            {
              "id": "capability-4",
              "title": "Согласование перспективы",
              "description": "Проверьте горизонт, направление линий и масштаб."
            },
            {
              "id": "capability-5",
              "title": "Контроль света",
              "description": "Тень, блики и температура должны соответствовать окружению."
            }
          ]
        },
        "workflow": {
          "h2": "Как получить контролируемый результат",
          "steps": [
            {
              "index": 1,
              "title": "Выделите область",
              "description": "Захватите предмет и достаточно окружения для восстановления контекста."
            },
            {
              "index": 2,
              "title": "Опишите действие",
              "description": "Укажите, что убрать или какой объект добавить вместо выбранной области."
            },
            {
              "index": 3,
              "title": "Проверьте детали",
              "description": "Сравните текстуры, линии, свет, тень и пропорции с исходной сценой."
            }
          ]
        },
        "useCases": {
          "h2": "Для каких задач подходит",
          "items": [
            {
              "title": "Убрать прохожего",
              "description": "Очистить фон туристического или городского кадра."
            },
            {
              "title": "Удалить предмет",
              "description": "Освободить стол, стену или часть интерьера."
            },
            {
              "title": "Добавить реквизит",
              "description": "Поддержать сюжет публикации новым элементом."
            },
            {
              "title": "Исправить композицию",
              "description": "Заменить отвлекающую деталь на более спокойную."
            }
          ]
        },
        "audience": {
          "h2": "Кому подойдёт этот сценарий",
          "items": [
            {
              "label": "Кому",
              "body": "Пользователи, которым нужно убрать помеху или добавить новый элемент, сохранив остальную сцену."
            },
            {
              "label": "Когда особенно полезно",
              "body": "После удаления остаются повторяющиеся текстуры, а добавленный объект не совпадает по свету, масштабу или перспективе."
            },
            {
              "label": "Подход",
              "body": "Локальная правка с контролем маски и окружающего контекста."
            }
          ]
        },
        "benefits": {
          "h2": "Почему такой порядок работает",
          "items": [
            {
              "title": "Остальной кадр сохраняется",
              "description": "Изменение ограничено выбранной областью и её контекстом."
            },
            {
              "title": "Результат оценивается по сцене",
              "description": "Важны не только объект, но и линии, тени и повторяющиеся текстуры."
            },
            {
              "title": "Правку можно повторить",
              "description": "Маленькие области проще контролировать несколькими последовательными изменениями."
            }
          ]
        },
        "limits": {
          "h2": "Что проверить перед началом",
          "body": "Доступность конкретных функций, режимов, лимитов и вариантов экспорта может меняться. Проверяйте актуальные условия в своём аккаунте и на официальном сайте Canva."
        },
        "related": {
          "h2": "Связанные задачи",
          "links": [
            {
              "route": "/redaktor-foto/",
              "anchor": "Редактируйте фото в одном рабочем пространстве"
            },
            {
              "route": "/udalit-fon/",
              "anchor": "Удалите фон с фото и получите чистый объект"
            },
            {
              "route": "/zamenit-fon-na-foto/",
              "anchor": "Замените фон на фото, сохранив главный объект"
            }
          ]
        },
        "faq": {
          "h2": "Частые вопросы",
          "items": [
            {
              "question": "Как удалить лишний объект с фото?",
              "answer": "Выделите объект с небольшим запасом вокруг, примените удаление и проверьте восстановленный фон."
            },
            {
              "question": "Можно ли добавить предмет по описанию?",
              "answer": "Такой сценарий возможен в инструментах генеративного редактирования. Доступность режима проверяйте в Canva."
            },
            {
              "question": "Почему после удаления появляется повторяющийся узор?",
              "answer": "Модель восстанавливает область по соседним пикселям и может дублировать текстуру. Уменьшите область или повторите правку."
            },
            {
              "question": "Как сохранить лицо и руки без изменений?",
              "answer": "Не включайте их в маску и отдельно укажите, что идентичность и анатомические детали должны остаться исходными."
            },
            {
              "question": "Чем это отличается от замены фона?",
              "answer": "Здесь меняется локальный объект внутри сцены, а при замене фона перестраивается всё окружение за главным объектом."
            }
          ]
        },
        "finalCta": {
          "h2": "Перейдите к нужному результату",
          "description": "Выберите подходящий сценарий, проверьте исходные материалы и начните работу в Canva.",
          "primaryCta": "Попробовать бесплатно"
        }
      }
    },
    "images": [
      {
        "assetId": "dobavit-udalit-obekt-na-foto-visual-01",
        "section": "hero",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "улица до и после удаления прохожего",
        "src": "/assets/generated/dobavit-udalit-obekt-na-foto-visual-01.webp"
      },
      {
        "assetId": "dobavit-udalit-obekt-na-foto-visual-02",
        "section": "product-proof",
        "action": "REPLACE_WITH_PRODUCT_UI",
        "purpose": "локальная маска вокруг предмета",
        "src": null
      },
      {
        "assetId": "dobavit-udalit-obekt-na-foto-visual-03",
        "section": "examples",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "добавленный объект с согласованной тенью",
        "src": "/assets/generated/dobavit-udalit-obekt-na-foto-visual-03.webp"
      }
    ]
  },
  {
    "key": "generator-izobrazhenij",
    "route": "/generator-izobrazhenij/",
    "content": {
      "page": "/generator-izobrazhenij/",
      "meta": {
        "title": "Генератор изображений по текстовому запросу",
        "description": "Как создать изображение по описанию в Canva: составить запрос, выбрать композицию и формат, сравнить варианты и доработать результат.",
        "h1": "Генератор изображений по текстовому запросу",
        "ogTitle": "Генератор изображений по текстовому запросу",
        "ogDescription": "Как создать изображение по описанию в Canva: составить запрос, выбрать композицию и формат, сравнить варианты и доработать результат."
      },
      "sections": {
        "hero": {
          "eyebrow": "Практический сценарий",
          "h1": "Генератор изображений по текстовому запросу",
          "subtitle": "Опишите сюжет и композицию, получите варианты и выберите основу для будущего дизайна.",
          "primaryCta": "Попробовать бесплатно",
          "secondaryCta": ""
        },
        "capabilities": {
          "h2": "Что входит в этот сценарий",
          "cards": [
            {
              "id": "capability-1",
              "title": "Сюжет и действие",
              "description": "Зафиксируйте, что происходит в кадре и какой объект главный."
            },
            {
              "id": "capability-2",
              "title": "Стиль и материал",
              "description": "Опишите фотографию, иллюстрацию, коллаж или другое визуальное направление."
            },
            {
              "id": "capability-3",
              "title": "Свет и камера",
              "description": "Укажите характер освещения, крупность и точку наблюдения."
            },
            {
              "id": "capability-4",
              "title": "Композиция под макет",
              "description": "Оставьте безопасную область для текста, кнопки или другого элемента."
            },
            {
              "id": "capability-5",
              "title": "Формат результата",
              "description": "Сразу учитывайте вертикальное, квадратное или горизонтальное применение."
            }
          ]
        },
        "workflow": {
          "h2": "Как получить контролируемый результат",
          "steps": [
            {
              "index": 1,
              "title": "Соберите запрос",
              "description": "Опишите объект, действие, среду, свет и композицию."
            },
            {
              "index": 2,
              "title": "Сравните варианты",
              "description": "Выберите кадр с правильной идеей, а не только с привлекательным цветом."
            },
            {
              "index": 3,
              "title": "Доработайте основу",
              "description": "Исправьте детали и поместите изображение в нужный дизайн."
            }
          ]
        },
        "useCases": {
          "h2": "Для каких задач подходит",
          "items": [
            {
              "title": "Пост",
              "description": "Квадратная или вертикальная сцена с ясным фокусом."
            },
            {
              "title": "Презентация",
              "description": "Горизонтальная иллюстрация с местом для заголовка."
            },
            {
              "title": "Карточка товара",
              "description": "Контролируемый фон и понятная предметная композиция."
            },
            {
              "title": "Концепт",
              "description": "Несколько направлений для обсуждения перед финальной съёмкой или дизайном."
            }
          ]
        },
        "audience": {
          "h2": "Кому подойдёт этот сценарий",
          "items": [
            {
              "label": "Кому",
              "body": "Пользователи, которым нужен новый визуал по описанию для публикации, презентации или макета."
            },
            {
              "label": "Когда особенно полезно",
              "body": "Запрос даёт случайный кадр, если в нём нет объекта, действия, среды, света и композиции."
            },
            {
              "label": "Подход",
              "body": "Практический генераторный сценарий от промпта к выбранному результату."
            }
          ]
        },
        "benefits": {
          "h2": "Почему такой порядок работает",
          "items": [
            {
              "title": "Запрос как техническое задание",
              "description": "Чем конкретнее сцена и композиция, тем проще оценивать варианты."
            },
            {
              "title": "Результат под применение",
              "description": "Пропорции и свободные зоны планируются до генерации."
            },
            {
              "title": "Отбор вместо случайности",
              "description": "Несколько вариантов сравниваются по задаче, а не по эффектности."
            }
          ]
        },
        "limits": {
          "h2": "Что проверить перед началом",
          "body": "Доступность конкретных функций, режимов, лимитов и вариантов экспорта может меняться. Проверяйте актуальные условия в своём аккаунте и на официальном сайте Canva."
        },
        "related": {
          "h2": "Связанные задачи",
          "links": [
            {
              "route": "/nejroset-dlya-izobrazhenij/",
              "anchor": "Нейросеть для создания и изменения изображений"
            },
            {
              "route": "/sozdat-dizajn/",
              "anchor": "Создайте дизайн под конкретный формат"
            },
            {
              "route": "/nejroset-dlya-prezentacij/",
              "anchor": "Создайте презентацию из темы с помощью ИИ"
            }
          ]
        },
        "faq": {
          "h2": "Частые вопросы",
          "items": [
            {
              "question": "Что написать в запросе для генератора?",
              "answer": "Укажите объект, действие, среду, время или свет, стиль, камеру, композицию и формат."
            },
            {
              "question": "Можно ли создать изображение на русском языке?",
              "answer": "Русский запрос можно использовать, но точность интерпретации зависит от текущей модели и формулировки."
            },
            {
              "question": "Как оставить место под текст?",
              "answer": "Попросите разместить главный объект в правой или левой трети и оставить чистую область на противоположной стороне."
            },
            {
              "question": "Почему на изображении появляется неправильный текст?",
              "answer": "Генеративные модели могут искажать буквы. Заголовки, кнопки и интерфейс лучше добавлять средствами дизайна."
            },
            {
              "question": "Чем генератор отличается от редактора фото?",
              "answer": "Генератор создаёт новый визуал, а редактор изменяет уже существующий снимок."
            }
          ]
        },
        "finalCta": {
          "h2": "Перейдите к нужному результату",
          "description": "Выберите подходящий сценарий, проверьте исходные материалы и начните работу в Canva.",
          "primaryCta": "Попробовать бесплатно"
        }
      }
    },
    "images": [
      {
        "assetId": "generator-izobrazhenij-visual-01",
        "section": "hero",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "чистое поле идеи и три результата без интерфейсного текста",
        "src": "/assets/generated/generator-izobrazhenij-visual-01.webp"
      },
      {
        "assetId": "generator-izobrazhenij-visual-02",
        "section": "product-proof",
        "action": "REPLACE_WITH_PRODUCT_UI",
        "purpose": "сравнение вариантов по композиции",
        "src": null
      },
      {
        "assetId": "generator-izobrazhenij-visual-03",
        "section": "examples",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "изображение с безопасной зоной под заголовок",
        "src": "/assets/generated/generator-izobrazhenij-visual-03.webp"
      }
    ]
  },
  {
    "key": "nejroset-dlya-foto",
    "route": "/nejroset-dlya-foto/",
    "content": {
      "page": "/nejroset-dlya-foto/",
      "meta": {
        "title": "Нейросеть для обработки и изменения фото",
        "description": "Сценарии работы с фото с помощью ИИ в Canva: улучшение кадра, замена фона, изменение объектов и подготовка вариаций.",
        "h1": "Нейросеть для обработки и изменения фото",
        "ogTitle": "Нейросеть для обработки и изменения фото",
        "ogDescription": "Сценарии работы с фото с помощью ИИ в Canva: улучшение кадра, замена фона, изменение объектов и подготовка вариаций."
      },
      "sections": {
        "hero": {
          "eyebrow": "Практический сценарий",
          "h1": "Нейросеть для обработки и изменения фото",
          "subtitle": "Загрузите снимок, сформулируйте изменение и сравните результат с исходником перед публикацией.",
          "primaryCta": "Попробовать бесплатно",
          "secondaryCta": ""
        },
        "capabilities": {
          "h2": "Что входит в этот сценарий",
          "cards": [
            {
              "id": "capability-1",
              "title": "Улучшить кадр",
              "description": "Скорректируйте визуальное качество и проверьте естественность деталей."
            },
            {
              "id": "capability-2",
              "title": "Изменить фон",
              "description": "Сохраните главный объект и поместите его в подходящее окружение."
            },
            {
              "id": "capability-3",
              "title": "Удалить лишнее",
              "description": "Очистите кадр от отвлекающего предмета или человека."
            },
            {
              "id": "capability-4",
              "title": "Добавить объект",
              "description": "Опишите новый элемент и проверьте масштаб, свет и перспективу."
            },
            {
              "id": "capability-5",
              "title": "Создать вариацию",
              "description": "Попробуйте другое настроение или композиционное направление на основе фото."
            }
          ]
        },
        "workflow": {
          "h2": "Как получить контролируемый результат",
          "steps": [
            {
              "index": 1,
              "title": "Загрузите снимок",
              "description": "Выберите исходник, где главный объект хорошо различим."
            },
            {
              "index": 2,
              "title": "Опишите изменение",
              "description": "Укажите, что сохранить и что именно нужно изменить."
            },
            {
              "index": 3,
              "title": "Сравните результат",
              "description": "Проверьте лицо, руки, текстуры, края и мелкие узнаваемые детали."
            }
          ]
        },
        "useCases": {
          "h2": "Для каких задач подходит",
          "items": [
            {
              "title": "Портрет",
              "description": "Улучшить фон и свет, сохранив узнаваемость человека."
            },
            {
              "title": "Товар",
              "description": "Подготовить чистое окружение для карточки или рекламы."
            },
            {
              "title": "Соцсети",
              "description": "Адаптировать настроение кадра под публикацию."
            },
            {
              "title": "Архивное фото",
              "description": "Подготовить снимок к восстановлению или лёгкой анимации."
            }
          ]
        },
        "audience": {
          "h2": "Кому подойдёт этот сценарий",
          "items": [
            {
              "label": "Кому",
              "body": "Пользователи, которым нужно изменить существующее фото или создать его вариацию с помощью текстового описания."
            },
            {
              "label": "Когда особенно полезно",
              "body": "Ручная ретушь требует опыта, а универсальный запрос без понятного результата даёт непредсказуемые изменения."
            },
            {
              "label": "Подход",
              "body": "Категория ИИ-операций с фото: улучшение, фон, объекты, стилизация и вариации."
            }
          ]
        },
        "benefits": {
          "h2": "Почему такой порядок работает",
          "items": [
            {
              "title": "Изменение по задаче",
              "description": "Каждый инструмент отвечает за конкретный результат, а не за абстрактную обработку."
            },
            {
              "title": "Сравнение с оригиналом",
              "description": "Исходник остаётся точкой контроля качества и идентичности."
            },
            {
              "title": "Следующий шаг рядом",
              "description": "После обработки можно перейти к фону, объектам, коллажу или дизайну."
            }
          ]
        },
        "limits": {
          "h2": "Что проверить перед началом",
          "body": "Доступность конкретных функций, режимов, лимитов и вариантов экспорта может меняться. Проверяйте актуальные условия в своём аккаунте и на официальном сайте Canva."
        },
        "related": {
          "h2": "Связанные задачи",
          "links": [
            {
              "route": "/redaktor-foto/",
              "anchor": "Редактируйте фото в одном рабочем пространстве"
            },
            {
              "route": "/zamenit-fon-na-foto/",
              "anchor": "Замените фон на фото, сохранив главный объект"
            },
            {
              "route": "/udalit-fon/",
              "anchor": "Удалите фон с фото и получите чистый объект"
            },
            {
              "route": "/dobavit-udalit-obekt-na-foto/",
              "anchor": "Добавьте или удалите объект на фото"
            }
          ]
        },
        "faq": {
          "h2": "Частые вопросы",
          "items": [
            {
              "question": "Чем нейросеть для фото отличается от фоторедактора?",
              "answer": "Нейросеть интерпретирует текстовую задачу или автоматически изменяет область, а обычный редактор даёт точные ручные настройки."
            },
            {
              "question": "Можно ли сохранить лицо без изменений?",
              "answer": "Формулируйте, что идентичность и черты нужно сохранить, затем внимательно сравнивайте результат с оригиналом."
            },
            {
              "question": "Какие фото лучше подходят для обработки?",
              "answer": "Чёткие снимки с различимым объектом, достаточным освещением и без сильного перекрытия важных деталей."
            },
            {
              "question": "Можно ли удалить фон и объект одним запросом?",
              "answer": "Лучше выполнять разные операции последовательно, чтобы контролировать края, композицию и итоговое качество."
            },
            {
              "question": "Где проверить доступность функций?",
              "answer": "Актуальные возможности, лимиты и условия отображаются в вашем аккаунте Canva."
            }
          ]
        },
        "finalCta": {
          "h2": "Перейдите к нужному результату",
          "description": "Выберите подходящий сценарий, проверьте исходные материалы и начните работу в Canva.",
          "primaryCta": "Попробовать бесплатно"
        }
      }
    },
    "images": [
      {
        "assetId": "nejroset-dlya-foto-visual-01",
        "section": "hero",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "портрет с тремя аккуратными вариантами обработки",
        "src": "/assets/generated/nejroset-dlya-foto-visual-01.webp"
      },
      {
        "assetId": "nejroset-dlya-foto-visual-02",
        "section": "product-proof",
        "action": "REPLACE_WITH_PRODUCT_UI",
        "purpose": "сравнение исходника и изменённого фото",
        "src": null
      },
      {
        "assetId": "nejroset-dlya-foto-visual-03",
        "section": "examples",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "набор сценариев фон, объект и улучшение",
        "src": "/assets/generated/nejroset-dlya-foto-visual-03.webp"
      }
    ]
  },
  {
    "key": "nejroset-dlya-izobrazhenij",
    "route": "/nejroset-dlya-izobrazhenij/",
    "content": {
      "page": "/nejroset-dlya-izobrazhenij/",
      "meta": {
        "title": "Нейросеть для создания и изменения изображений",
        "description": "Как использовать ИИ в Canva для генерации, вариаций и изменения изображений. Сценарии, запросы, контроль композиции и ограничения.",
        "h1": "Нейросеть для создания и изменения изображений",
        "ogTitle": "Нейросеть для создания и изменения изображений",
        "ogDescription": "Как использовать ИИ в Canva для генерации, вариаций и изменения изображений. Сценарии, запросы, контроль композиции и ограничения."
      },
      "sections": {
        "hero": {
          "eyebrow": "Практический сценарий",
          "h1": "Нейросеть для создания и изменения изображений",
          "subtitle": "Начните с текста или исходного визуала, выберите операцию и доведите результат до нужного формата.",
          "primaryCta": "Попробовать бесплатно",
          "secondaryCta": ""
        },
        "capabilities": {
          "h2": "Что входит в этот сценарий",
          "cards": [
            {
              "id": "capability-1",
              "title": "Текст в изображение",
              "description": "Опишите сюжет, стиль, свет, композицию и формат будущего кадра."
            },
            {
              "id": "capability-2",
              "title": "Изображение в вариацию",
              "description": "Используйте исходник как визуальную опору для нового направления."
            },
            {
              "id": "capability-3",
              "title": "Локальное изменение",
              "description": "Меняйте выбранную область, не перестраивая весь кадр без необходимости."
            },
            {
              "id": "capability-4",
              "title": "Расширение композиции",
              "description": "Подготовьте дополнительное пространство под другой формат макета."
            },
            {
              "id": "capability-5",
              "title": "Серия в одном стиле",
              "description": "Зафиксируйте палитру, свет и характер материала для связанных визуалов."
            }
          ]
        },
        "workflow": {
          "h2": "Как получить контролируемый результат",
          "steps": [
            {
              "index": 1,
              "title": "Выберите исходную точку",
              "description": "Решите, нужен новый визуал или изменение готового изображения."
            },
            {
              "index": 2,
              "title": "Опишите контрольные параметры",
              "description": "Укажите главный объект, действие, среду, свет и расположение в кадре."
            },
            {
              "index": 3,
              "title": "Отберите и доработайте",
              "description": "Сравните варианты, исправьте детали и адаптируйте пропорции."
            }
          ]
        },
        "useCases": {
          "h2": "Для каких задач подходит",
          "items": [
            {
              "title": "Концепция",
              "description": "Быстро проверить визуальное направление идеи."
            },
            {
              "title": "Рекламный макет",
              "description": "Создать основу с безопасным пространством под текст."
            },
            {
              "title": "Иллюстрация",
              "description": "Подготовить сцену для статьи, презентации или документа."
            },
            {
              "title": "Серия контента",
              "description": "Собрать несколько связанных изображений в едином стиле."
            }
          ]
        },
        "audience": {
          "h2": "Кому подойдёт этот сценарий",
          "items": [
            {
              "label": "Кому",
              "body": "Люди, которым нужен широкий обзор сценариев генерации, вариаций и редактирования изображений."
            },
            {
              "label": "Когда особенно полезно",
              "body": "Непонятно, начинать с текста, фото или существующего макета, и как контролировать стиль и композицию."
            },
            {
              "label": "Подход",
              "body": "Широкий ИИ-хаб про входы, операции и типы результата."
            }
          ]
        },
        "benefits": {
          "h2": "Почему такой порядок работает",
          "items": [
            {
              "title": "Несколько типов входа",
              "description": "Можно начинать с описания или существующего изображения."
            },
            {
              "title": "Управляемая композиция",
              "description": "Запрос учитывает объект, свет, камеру, цвет и свободные зоны."
            },
            {
              "title": "Связь с дизайном",
              "description": "Готовый результат становится материалом для макета, а не отдельным файлом без контекста."
            }
          ]
        },
        "limits": {
          "h2": "Что проверить перед началом",
          "body": "Доступность конкретных функций, режимов, лимитов и вариантов экспорта может меняться. Проверяйте актуальные условия в своём аккаунте и на официальном сайте Canva."
        },
        "related": {
          "h2": "Связанные задачи",
          "links": [
            {
              "route": "/generator-izobrazhenij/",
              "anchor": "Генератор изображений по текстовому запросу"
            },
            {
              "route": "/nejroset-dlya-foto/",
              "anchor": "Нейросеть для обработки и изменения фото"
            },
            {
              "route": "/sozdat-dizajn/",
              "anchor": "Создайте дизайн под конкретный формат"
            }
          ]
        },
        "faq": {
          "h2": "Частые вопросы",
          "items": [
            {
              "question": "Что умеет нейросеть для изображений?",
              "answer": "Создавать новые изображения по описанию, предлагать вариации и изменять отдельные области. Конкретный набор функций зависит от текущей версии Canva."
            },
            {
              "question": "Чем эта страница отличается от генератора изображений?",
              "answer": "Здесь рассматривается весь набор ИИ-операций, а генератор сфокусирован на получении нового изображения по запросу."
            },
            {
              "question": "Как написать понятный запрос?",
              "answer": "Укажите объект, действие, окружение, свет, стиль, композицию, пропорции и то, чего в кадре быть не должно."
            },
            {
              "question": "Можно ли использовать исходное фото?",
              "answer": "Некоторые сценарии начинаются с загруженного изображения. Проверяйте доступность режима и требования к файлу."
            },
            {
              "question": "Почему результат нужно проверять?",
              "answer": "ИИ может искажать мелкие детали, руки, текст, логотипы или идентичность персонажа. Финальная проверка обязательна."
            }
          ]
        },
        "finalCta": {
          "h2": "Перейдите к нужному результату",
          "description": "Выберите подходящий сценарий, проверьте исходные материалы и начните работу в Canva.",
          "primaryCta": "Попробовать бесплатно"
        }
      }
    },
    "images": [
      {
        "assetId": "nejroset-dlya-izobrazhenij-visual-01",
        "section": "hero",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "текстовый замысел превращается в три типа изображения",
        "src": "/assets/generated/nejroset-dlya-izobrazhenij-visual-01.webp"
      },
      {
        "assetId": "nejroset-dlya-izobrazhenij-visual-02",
        "section": "product-proof",
        "action": "REPLACE_WITH_PRODUCT_UI",
        "purpose": "одно изображение в нескольких управляемых вариациях",
        "src": null
      },
      {
        "assetId": "nejroset-dlya-izobrazhenij-visual-03",
        "section": "examples",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "сетка сюжет, свет, композиция и формат",
        "src": "/assets/generated/nejroset-dlya-izobrazhenij-visual-03.webp"
      }
    ]
  },
  {
    "key": "nejroset-dlya-prezentacij",
    "route": "/nejroset-dlya-prezentacij/",
    "content": {
      "page": "/nejroset-dlya-prezentacij/",
      "meta": {
        "title": "Нейросеть для создания презентаций",
        "description": "Как создать структуру и первый вариант презентации с помощью ИИ в Canva: тема, план, слайды, визуалы и ручная доработка.",
        "h1": "Создайте презентацию из темы с помощью ИИ",
        "ogTitle": "Нейросеть для создания презентаций",
        "ogDescription": "Как создать структуру и первый вариант презентации с помощью ИИ в Canva: тема, план, слайды, визуалы и ручная доработка."
      },
      "sections": {
        "hero": {
          "eyebrow": "Практический сценарий",
          "h1": "Создайте презентацию из темы с помощью ИИ",
          "subtitle": "Получите структуру слайдов, проверьте логику рассказа и доработайте каждый экран под аудиторию.",
          "primaryCta": "Попробовать бесплатно",
          "secondaryCta": ""
        },
        "capabilities": {
          "h2": "Что входит в этот сценарий",
          "cards": [
            {
              "id": "capability-1",
              "title": "План по теме",
              "description": "Сформируйте последовательность разделов до работы над оформлением."
            },
            {
              "id": "capability-2",
              "title": "Черновики слайдов",
              "description": "Разложите основные тезисы по отдельным экранам."
            },
            {
              "id": "capability-3",
              "title": "Визуальное направление",
              "description": "Подберите единый характер изображений, цвета и композиции."
            },
            {
              "id": "capability-4",
              "title": "Редактирование текста",
              "description": "Сократите перегруженные формулировки и уточните ключевые мысли."
            },
            {
              "id": "capability-5",
              "title": "Адаптация формата",
              "description": "Подготовьте материал для выступления, урока или внутренней встречи."
            }
          ]
        },
        "workflow": {
          "h2": "Как получить контролируемый результат",
          "steps": [
            {
              "index": 1,
              "title": "Опишите тему",
              "description": "Укажите предмет, аудиторию и желаемый результат выступления."
            },
            {
              "index": 2,
              "title": "Проверьте структуру",
              "description": "Удалите повторы и убедитесь, что каждый слайд продолжает предыдущий."
            },
            {
              "index": 3,
              "title": "Доработайте дизайн",
              "description": "Настройте текст, изображения и композицию перед показом или экспортом."
            }
          ]
        },
        "useCases": {
          "h2": "Для каких задач подходит",
          "items": [
            {
              "title": "Рабочий отчёт",
              "description": "Показать выводы, аргументы и следующий шаг."
            },
            {
              "title": "Учебная презентация",
              "description": "Объяснить тему понятной последовательностью слайдов."
            },
            {
              "title": "Коммерческое предложение",
              "description": "Связать проблему клиента, решение и ожидаемый результат."
            },
            {
              "title": "Публичное выступление",
              "description": "Собрать визуальную опору без перегрузки текстом."
            }
          ]
        },
        "audience": {
          "h2": "Кому подойдёт этот сценарий",
          "items": [
            {
              "label": "Кому",
              "body": "Специалисты, студенты и команды, которым нужно быстро перейти от темы к логичной структуре слайдов."
            },
            {
              "label": "Когда особенно полезно",
              "body": "Чистый лист, слабая структура рассказа и много времени на ручную компоновку каждого слайда."
            },
            {
              "label": "Подход",
              "body": "Сначала логика презентации, затем визуальный ритм и проверка каждого слайда."
            }
          ]
        },
        "benefits": {
          "h2": "Почему такой порядок работает",
          "items": [
            {
              "title": "Структура до оформления",
              "description": "Сначала выстраивается логика, поэтому дизайн не маскирует слабый рассказ."
            },
            {
              "title": "Единый ритм",
              "description": "Слайды выглядят частью одной истории, а не набором случайных шаблонов."
            },
            {
              "title": "Контроль автора",
              "description": "ИИ помогает с черновиком, но финальные факты и формулировки проверяет пользователь."
            }
          ]
        },
        "limits": {
          "h2": "Что проверить перед началом",
          "body": "Доступность конкретных функций, режимов, лимитов и вариантов экспорта может меняться. Проверяйте актуальные условия в своём аккаунте и на официальном сайте Canva."
        },
        "related": {
          "h2": "Связанные задачи",
          "links": [
            {
              "route": "/sozdat-dizajn/",
              "anchor": "Создайте дизайн под конкретный формат"
            },
            {
              "route": "/generator-izobrazhenij/",
              "anchor": "Генератор изображений по текстовому запросу"
            },
            {
              "route": "/nejroset-dlya-izobrazhenij/",
              "anchor": "Нейросеть для создания и изменения изображений"
            }
          ]
        },
        "faq": {
          "h2": "Частые вопросы",
          "items": [
            {
              "question": "Может ли нейросеть создать презентацию по одной теме?",
              "answer": "Да, такой сценарий предполагает генерацию структуры и чернового наполнения. Итог нужно проверить и адаптировать под реальную аудиторию."
            },
            {
              "question": "Можно ли подготовить презентацию на русском языке?",
              "answer": "Русский текст можно использовать в содержании и запросах. Актуальную доступность конкретных функций проверяйте в интерфейсе Canva."
            },
            {
              "question": "Нужно ли редактировать результат?",
              "answer": "Да. Проверьте факты, порядок аргументов, длину текста и уместность изображений на каждом слайде."
            },
            {
              "question": "Чем ИИ-презентация отличается от шаблона?",
              "answer": "Шаблон задаёт визуальную форму, а ИИ-сценарий помогает начать со структуры и содержания по вашей теме."
            },
            {
              "question": "Можно ли скачать презентацию?",
              "answer": "Варианты экспорта зависят от текущих возможностей и тарифа Canva. Проверьте их перед началом работы."
            }
          ]
        },
        "finalCta": {
          "h2": "Перейдите к нужному результату",
          "description": "Выберите подходящий сценарий, проверьте исходные материалы и начните работу в Canva.",
          "primaryCta": "Попробовать бесплатно"
        }
      }
    },
    "images": [
      {
        "assetId": "nejroset-dlya-prezentacij-visual-01",
        "section": "hero",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "стопка слайдов от плана к готовому экрану",
        "src": "/assets/generated/nejroset-dlya-prezentacij-visual-01.webp"
      },
      {
        "assetId": "nejroset-dlya-prezentacij-visual-02",
        "section": "product-proof",
        "action": "REPLACE_WITH_PRODUCT_UI",
        "purpose": "редактируемая презентация с ясной иерархией",
        "src": null
      },
      {
        "assetId": "nejroset-dlya-prezentacij-visual-03",
        "section": "examples",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "три варианта визуальной подачи одной темы",
        "src": "/assets/generated/nejroset-dlya-prezentacij-visual-03.webp"
      }
    ]
  },
  {
    "key": "obedinit-foto",
    "route": "/obedinit-foto/",
    "content": {
      "page": "/obedinit-foto/",
      "meta": {
        "title": "Объединить несколько фото в один дизайн",
        "description": "Как объединить два или несколько фото в Canva: выбрать сетку, выровнять кадры, согласовать цвет и подготовить коллаж или сравнение.",
        "h1": "Объедините несколько фото в один дизайн",
        "ogTitle": "Объединить несколько фото в один дизайн",
        "ogDescription": "Как объединить два или несколько фото в Canva: выбрать сетку, выровнять кадры, согласовать цвет и подготовить коллаж или сравнение."
      },
      "sections": {
        "hero": {
          "eyebrow": "Практический сценарий",
          "h1": "Объедините несколько фото в один дизайн",
          "subtitle": "Соберите снимки в коллаж, ряд или сравнение и настройте единый ритм композиции.",
          "primaryCta": "Попробовать бесплатно",
          "secondaryCta": ""
        },
        "capabilities": {
          "h2": "Что входит в этот сценарий",
          "cards": [
            {
              "id": "capability-1",
              "title": "Сетка под сюжет",
              "description": "Выберите равные кадры, главный акцент или последовательную фотоленту."
            },
            {
              "id": "capability-2",
              "title": "Единые пропорции",
              "description": "Кадрируйте снимки так, чтобы важные объекты не пропадали."
            },
            {
              "id": "capability-3",
              "title": "Выравнивание и интервалы",
              "description": "Используйте одинаковые края, отступы и направляющие."
            },
            {
              "id": "capability-4",
              "title": "Общий цветовой тон",
              "description": "Сведите яркость и температуру разных снимков."
            },
            {
              "id": "capability-5",
              "title": "Подписи средствами дизайна",
              "description": "Добавляйте текст отдельно, чтобы он оставался читаемым и редактируемым."
            }
          ]
        },
        "workflow": {
          "h2": "Как получить контролируемый результат",
          "steps": [
            {
              "index": 1,
              "title": "Выберите фотографии",
              "description": "Определите главный кадр и роль каждого дополнительного снимка."
            },
            {
              "index": 2,
              "title": "Соберите композицию",
              "description": "Разместите фото в сетке, ряду, сравнении или свободном коллаже."
            },
            {
              "index": 3,
              "title": "Сведите детали",
              "description": "Проверьте кадрирование, интервалы, цвет и итоговый формат."
            }
          ]
        },
        "useCases": {
          "h2": "Для каких задач подходит",
          "items": [
            {
              "title": "До и после",
              "description": "Показать изменение двумя сопоставимыми кадрами."
            },
            {
              "title": "Карточка товара",
              "description": "Объединить общий вид, детали и вариант использования."
            },
            {
              "title": "История события",
              "description": "Собрать последовательность моментов в одном макете."
            },
            {
              "title": "Мудборд",
              "description": "Показать материалы, цвета и настроение проекта."
            }
          ]
        },
        "audience": {
          "h2": "Кому подойдёт этот сценарий",
          "items": [
            {
              "label": "Кому",
              "body": "Пользователи, которым нужен коллаж, ряд до и после, фотолента или единый макет из нескольких снимков."
            },
            {
              "label": "Когда особенно полезно",
              "body": "Фото имеют разные пропорции, цвет и масштаб, поэтому композиция выглядит случайной."
            },
            {
              "label": "Подход",
              "body": "Осмысленное объединение через сетку, выравнивание, ритм и общий визуальный тон."
            }
          ]
        },
        "benefits": {
          "h2": "Почему такой порядок работает",
          "items": [
            {
              "title": "Каждый кадр имеет роль",
              "description": "Композиция строится вокруг главного изображения и поддерживающих деталей."
            },
            {
              "title": "Фотографии читаются вместе",
              "description": "Единые интервалы и тон связывают разнородные материалы."
            },
            {
              "title": "Макет готов к публикации",
              "description": "Результат можно адаптировать под пост, презентацию или печатный формат."
            }
          ]
        },
        "limits": {
          "h2": "Что проверить перед началом",
          "body": "Доступность конкретных функций, режимов, лимитов и вариантов экспорта может меняться. Проверяйте актуальные условия в своём аккаунте и на официальном сайте Canva."
        },
        "related": {
          "h2": "Связанные задачи",
          "links": [
            {
              "route": "/redaktor-foto/",
              "anchor": "Редактируйте фото в одном рабочем пространстве"
            },
            {
              "route": "/sozdat-dizajn/",
              "anchor": "Создайте дизайн под конкретный формат"
            },
            {
              "route": "/udalit-fon/",
              "anchor": "Удалите фон с фото и получите чистый объект"
            }
          ]
        },
        "faq": {
          "h2": "Частые вопросы",
          "items": [
            {
              "question": "Как объединить два фото в одно?",
              "answer": "Добавьте оба снимка в макет, выберите расположение рядом или в сетке и настройте кадрирование."
            },
            {
              "question": "Можно ли сделать сравнение до и после?",
              "answer": "Да. Используйте одинаковые пропорции кадров и понятное направление чтения слева направо."
            },
            {
              "question": "Как объединить фото разного размера?",
              "answer": "Сначала выберите итоговую сетку, затем кадрируйте каждый снимок внутри своей области."
            },
            {
              "question": "Как сделать коллаж аккуратным?",
              "answer": "Ограничьте количество акцентов, используйте повторяющиеся интервалы и согласуйте яркость изображений."
            },
            {
              "question": "Можно ли добавить подписи?",
              "answer": "Да. Делайте подписи отдельными текстовыми элементами, а не частью растрового изображения."
            }
          ]
        },
        "finalCta": {
          "h2": "Перейдите к нужному результату",
          "description": "Выберите подходящий сценарий, проверьте исходные материалы и начните работу в Canva.",
          "primaryCta": "Попробовать бесплатно"
        }
      }
    },
    "images": [
      {
        "assetId": "obedinit-foto-visual-01",
        "section": "hero",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "коллаж из четырёх кадров с главным акцентом",
        "src": "/assets/generated/obedinit-foto-visual-01.webp"
      },
      {
        "assetId": "obedinit-foto-visual-02",
        "section": "product-proof",
        "action": "REPLACE_WITH_PRODUCT_UI",
        "purpose": "сравнение до и после одинакового масштаба",
        "src": null
      },
      {
        "assetId": "obedinit-foto-visual-03",
        "section": "examples",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "набор сеток для разных историй",
        "src": "/assets/generated/obedinit-foto-visual-03.webp"
      }
    ]
  },
  {
    "key": "ozhivit-foto",
    "route": "/ozhivit-foto/",
    "content": {
      "page": "/ozhivit-foto/",
      "meta": {
        "title": "Оживить фото с помощью ИИ",
        "description": "Как добавить движение фотографии в Canva: выбрать исходник, описать движение, проверить лицо и фон, подготовить короткий ролик.",
        "h1": "Оживите фото и добавьте движение кадру",
        "ogTitle": "Оживить фото с помощью ИИ",
        "ogDescription": "Как добавить движение фотографии в Canva: выбрать исходник, описать движение, проверить лицо и фон, подготовить короткий ролик."
      },
      "sections": {
        "hero": {
          "eyebrow": "Практический сценарий",
          "h1": "Оживите фото и добавьте движение кадру",
          "subtitle": "Задайте мягкое движение объекта или камеры и проверьте, что важные детали остаются узнаваемыми.",
          "primaryCta": "Попробовать бесплатно",
          "secondaryCta": ""
        },
        "capabilities": {
          "h2": "Что входит в этот сценарий",
          "cards": [
            {
              "id": "capability-1",
              "title": "Движение камеры",
              "description": "Используйте плавный наезд, отъезд или панораму без резких скачков."
            },
            {
              "id": "capability-2",
              "title": "Лёгкая мимика",
              "description": "Добавляйте минимальное движение лица и внимательно проверяйте идентичность."
            },
            {
              "id": "capability-3",
              "title": "Динамика среды",
              "description": "Оживите волосы, ткань, воду, свет или фоновые элементы."
            },
            {
              "id": "capability-4",
              "title": "Анимация рисунка",
              "description": "Превратите статичную иллюстрацию в короткую сцену."
            },
            {
              "id": "capability-5",
              "title": "Подготовка к публикации",
              "description": "Учитывайте длительность, ориентацию и безопасную область кадра."
            }
          ]
        },
        "workflow": {
          "h2": "Как получить контролируемый результат",
          "steps": [
            {
              "index": 1,
              "title": "Выберите исходник",
              "description": "Используйте чёткий кадр без перекрытия лица или главного объекта."
            },
            {
              "index": 2,
              "title": "Опишите движение",
              "description": "Укажите направление камеры и только те элементы, которые должны двигаться."
            },
            {
              "index": 3,
              "title": "Проверьте ролик",
              "description": "Оцените лицо, руки, фон, края и отсутствие нежелательных деформаций."
            }
          ]
        },
        "useCases": {
          "h2": "Для каких задач подходит",
          "items": [
            {
              "title": "Архивный портрет",
              "description": "Добавить спокойное движение без изменения личности."
            },
            {
              "title": "Пейзаж",
              "description": "Оживить воду, облака, листья или свет."
            },
            {
              "title": "Товарный кадр",
              "description": "Добавить небольшой ход камеры для презентации продукта."
            },
            {
              "title": "Иллюстрация",
              "description": "Создать короткую анимированную сцену для публикации."
            }
          ]
        },
        "audience": {
          "h2": "Кому подойдёт этот сценарий",
          "items": [
            {
              "label": "Кому",
              "body": "Пользователи, которым нужно добавить мягкое движение портрету, предмету, рисунку или сцене."
            },
            {
              "label": "Когда особенно полезно",
              "body": "Слишком сильная анимация искажает лицо, фон и мелкие детали, а направление движения выглядит случайным."
            },
            {
              "label": "Подход",
              "body": "Контролируемое движение камеры и объекта с обязательной проверкой идентичности."
            }
          ]
        },
        "benefits": {
          "h2": "Почему такой порядок работает",
          "items": [
            {
              "title": "Движение имеет сценарий",
              "description": "Камера и объект двигаются по описанной задаче, а не хаотично."
            },
            {
              "title": "Идентичность контролируется",
              "description": "Ключевые детали сравниваются с исходником после генерации."
            },
            {
              "title": "Формат планируется заранее",
              "description": "Вертикальный или горизонтальный кадр выбирается под место публикации."
            }
          ]
        },
        "limits": {
          "h2": "Что проверить перед началом",
          "body": "Доступность конкретных функций, режимов, лимитов и вариантов экспорта может меняться. Проверяйте актуальные условия в своём аккаунте и на официальном сайте Canva."
        },
        "related": {
          "h2": "Связанные задачи",
          "links": [
            {
              "route": "/nejroset-dlya-foto/",
              "anchor": "Нейросеть для обработки и изменения фото"
            },
            {
              "route": "/redaktor-foto/",
              "anchor": "Редактируйте фото в одном рабочем пространстве"
            },
            {
              "route": "/sozdat-dizajn/",
              "anchor": "Создайте дизайн под конкретный формат"
            }
          ]
        },
        "faq": {
          "h2": "Частые вопросы",
          "items": [
            {
              "question": "Что значит оживить фото?",
              "answer": "Добавить к статичному изображению движение камеры, объекта, лица или отдельных элементов и получить короткий видеорезультат."
            },
            {
              "question": "Какие фотографии подходят лучше?",
              "answer": "Чёткие снимки с хорошо видимым объектом, спокойным фоном и достаточным пространством вокруг движения."
            },
            {
              "question": "Как избежать искажения лица?",
              "answer": "Используйте минимальную мимику, короткое движение и обязательно сравнивайте каждый результат с оригиналом."
            },
            {
              "question": "Можно ли оживить старую фотографию?",
              "answer": "Да, но сначала полезно проверить резкость, повреждения и качество лица. Иногда требуется предварительное восстановление."
            },
            {
              "question": "Где проверить доступность анимации?",
              "answer": "Актуальные режимы, лимиты и экспорт нужно проверять в вашем аккаунте Canva."
            }
          ]
        },
        "finalCta": {
          "h2": "Перейдите к нужному результату",
          "description": "Выберите подходящий сценарий, проверьте исходные материалы и начните работу в Canva.",
          "primaryCta": "Попробовать бесплатно"
        }
      }
    },
    "images": [
      {
        "assetId": "ozhivit-foto-visual-01",
        "section": "hero",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "портрет с мягкой последовательностью движения",
        "src": "/assets/generated/ozhivit-foto-visual-01.webp"
      },
      {
        "assetId": "ozhivit-foto-visual-02",
        "section": "product-proof",
        "action": "REPLACE_WITH_PRODUCT_UI",
        "purpose": "пейзаж с направлением камеры и движением среды",
        "src": null
      },
      {
        "assetId": "ozhivit-foto-visual-03",
        "section": "examples",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "статичный кадр и короткая раскадровка",
        "src": "/assets/generated/ozhivit-foto-visual-03.webp"
      }
    ]
  },
  {
    "key": "redaktor-foto",
    "route": "/redaktor-foto/",
    "content": {
      "page": "/redaktor-foto/",
      "meta": {
        "title": "Редактор фото для обработки в одном месте",
        "description": "Как редактировать фото в Canva: кадрирование, цвет, фон, объекты, текст и подготовка изображения к публикации.",
        "h1": "Редактируйте фото в одном рабочем пространстве",
        "ogTitle": "Редактор фото для обработки в одном месте",
        "ogDescription": "Как редактировать фото в Canva: кадрирование, цвет, фон, объекты, текст и подготовка изображения к публикации."
      },
      "sections": {
        "hero": {
          "eyebrow": "Практический сценарий",
          "h1": "Редактируйте фото в одном рабочем пространстве",
          "subtitle": "Кадрируйте, настраивайте цвет, меняйте фон и добавляйте элементы без разрыва рабочего процесса.",
          "primaryCta": "Попробовать бесплатно",
          "secondaryCta": ""
        },
        "capabilities": {
          "h2": "Что входит в этот сценарий",
          "cards": [
            {
              "id": "capability-1",
              "title": "Кадрирование",
              "description": "Настройте пропорции и оставьте в кадре только важное."
            },
            {
              "id": "capability-2",
              "title": "Свет и цвет",
              "description": "Согласуйте яркость, контраст, температуру и насыщенность."
            },
            {
              "id": "capability-3",
              "title": "Фон",
              "description": "Удалите окружение или замените его под задачу макета."
            },
            {
              "id": "capability-4",
              "title": "Объекты",
              "description": "Уберите отвлекающий предмет или добавьте новый элемент."
            },
            {
              "id": "capability-5",
              "title": "Текст и публикация",
              "description": "Добавьте редактируемые подписи и подготовьте итоговый формат."
            }
          ]
        },
        "workflow": {
          "h2": "Как получить контролируемый результат",
          "steps": [
            {
              "index": 1,
              "title": "Откройте фотографию",
              "description": "Проверьте разрешение, ориентацию и основной объект."
            },
            {
              "index": 2,
              "title": "Выполните правки по порядку",
              "description": "Сначала кадр и тон, затем фон, объекты и текст."
            },
            {
              "index": 3,
              "title": "Проверьте итог",
              "description": "Посмотрите результат в реальном размере и выберите подходящий экспорт."
            }
          ]
        },
        "useCases": {
          "h2": "Для каких задач подходит",
          "items": [
            {
              "title": "Портрет",
              "description": "Кадрирование, свет, фон и аккуратная подпись."
            },
            {
              "title": "Товар",
              "description": "Чистый объект, нейтральный фон и формат карточки."
            },
            {
              "title": "Публикация",
              "description": "Цвет, композиция и текст под социальную сеть."
            },
            {
              "title": "Презентация",
              "description": "Подготовка изображения под горизонтальный слайд."
            }
          ]
        },
        "audience": {
          "h2": "Кому подойдёт этот сценарий",
          "items": [
            {
              "label": "Кому",
              "body": "Пользователи, которым нужно последовательно кадрировать, улучшить и подготовить фотографию к публикации."
            },
            {
              "label": "Когда особенно полезно",
              "body": "Приходится переключаться между сервисами, а после каждой операции качество и формат меняются непредсказуемо."
            },
            {
              "label": "Подход",
              "body": "Единый рабочий процесс от кадрирования до текста и экспорта."
            }
          ]
        },
        "benefits": {
          "h2": "Почему такой порядок работает",
          "items": [
            {
              "title": "Операции идут последовательно",
              "description": "Каждая правка опирается на предыдущую версию изображения."
            },
            {
              "title": "Ручные и ИИ-инструменты дополняют друг друга",
              "description": "Автоматическое изменение можно уточнить обычными настройками."
            },
            {
              "title": "Результат сразу входит в дизайн",
              "description": "После обработки фото не нужно переносить между несколькими программами."
            }
          ]
        },
        "limits": {
          "h2": "Что проверить перед началом",
          "body": "Доступность конкретных функций, режимов, лимитов и вариантов экспорта может меняться. Проверяйте актуальные условия в своём аккаунте и на официальном сайте Canva."
        },
        "related": {
          "h2": "Связанные задачи",
          "links": [
            {
              "route": "/nejroset-dlya-foto/",
              "anchor": "Нейросеть для обработки и изменения фото"
            },
            {
              "route": "/udalit-fon/",
              "anchor": "Удалите фон с фото и получите чистый объект"
            },
            {
              "route": "/zamenit-fon-na-foto/",
              "anchor": "Замените фон на фото, сохранив главный объект"
            },
            {
              "route": "/dobavit-udalit-obekt-na-foto/",
              "anchor": "Добавьте или удалите объект на фото"
            }
          ]
        },
        "faq": {
          "h2": "Частые вопросы",
          "items": [
            {
              "question": "Какие задачи решает редактор фото?",
              "answer": "Кадрирование, настройка цвета, работа с фоном, объектами, текстом и подготовка файла к публикации."
            },
            {
              "question": "Чем ИИ-редактор отличается от обычного?",
              "answer": "ИИ помогает интерпретировать задачу и изменять области автоматически, а ручные настройки дают точный контроль."
            },
            {
              "question": "В каком порядке обрабатывать фото?",
              "answer": "Сначала кадрирование и базовый тон, затем фон и объекты, после этого текст и финальная проверка."
            },
            {
              "question": "Как сохранить качество?",
              "answer": "Начинайте с достаточно крупного исходника, избегайте повторного сильного сжатия и проверяйте размер экспорта."
            },
            {
              "question": "Где узнать доступные форматы?",
              "answer": "Текущие варианты загрузки и экспорта отображаются в интерфейсе Canva и могут зависеть от аккаунта."
            }
          ]
        },
        "finalCta": {
          "h2": "Перейдите к нужному результату",
          "description": "Выберите подходящий сценарий, проверьте исходные материалы и начните работу в Canva.",
          "primaryCta": "Попробовать бесплатно"
        }
      }
    },
    "images": [
      {
        "assetId": "redaktor-foto-visual-01",
        "section": "hero",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "фото с аккуратной панелью настроек без текста внутри изображения",
        "src": "/assets/generated/redaktor-foto-visual-01.webp"
      },
      {
        "assetId": "redaktor-foto-visual-02",
        "section": "product-proof",
        "action": "REPLACE_WITH_PRODUCT_UI",
        "purpose": "последовательность кадр, цвет, фон и публикация",
        "src": null
      },
      {
        "assetId": "redaktor-foto-visual-03",
        "section": "examples",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "один снимок в форматах поста и слайда",
        "src": "/assets/generated/redaktor-foto-visual-03.webp"
      }
    ]
  },
  {
    "key": "sozdat-dizajn",
    "route": "/sozdat-dizajn/",
    "content": {
      "page": "/sozdat-dizajn/",
      "meta": {
        "title": "Создать дизайн под нужный формат",
        "description": "Как создать дизайн в Canva для поста, презентации, афиши или карточки товара: выбрать формат, собрать иерархию и проверить макет.",
        "h1": "Создайте дизайн под конкретный формат",
        "ogTitle": "Создать дизайн под нужный формат",
        "ogDescription": "Как создать дизайн в Canva для поста, презентации, афиши или карточки товара: выбрать формат, собрать иерархию и проверить макет."
      },
      "sections": {
        "hero": {
          "eyebrow": "Практический сценарий",
          "h1": "Создайте дизайн под конкретный формат",
          "subtitle": "Определите задачу и размер, соберите композицию и адаптируйте результат к месту публикации.",
          "primaryCta": "Попробовать бесплатно",
          "secondaryCta": ""
        },
        "capabilities": {
          "h2": "Что входит в этот сценарий",
          "cards": [
            {
              "id": "capability-1",
              "title": "Формат до композиции",
              "description": "Сначала выберите место использования и нужные пропорции."
            },
            {
              "id": "capability-2",
              "title": "Главное сообщение",
              "description": "Определите один основной заголовок и следующий шаг пользователя."
            },
            {
              "id": "capability-3",
              "title": "Визуальная иерархия",
              "description": "Разделите главное, поддерживающее и служебное содержание."
            },
            {
              "id": "capability-4",
              "title": "Материалы в одной системе",
              "description": "Согласуйте фотографии, цвет, типографику и формы."
            },
            {
              "id": "capability-5",
              "title": "Проверка перед экспортом",
              "description": "Оцените читаемость, поля, качество изображений и итоговый файл."
            }
          ]
        },
        "workflow": {
          "h2": "Как получить контролируемый результат",
          "steps": [
            {
              "index": 1,
              "title": "Выберите формат",
              "description": "Пост, презентация, афиша, карточка товара или другой носитель."
            },
            {
              "index": 2,
              "title": "Соберите основу",
              "description": "Разместите главное сообщение, визуал и поддерживающие элементы."
            },
            {
              "index": 3,
              "title": "Адаптируйте результат",
              "description": "Проверьте макет на целевом размере и подготовьте нужный вариант экспорта."
            }
          ]
        },
        "useCases": {
          "h2": "Для каких задач подходит",
          "items": [
            {
              "title": "Социальные сети",
              "description": "Пост, история, обложка или рекламный креатив."
            },
            {
              "title": "Работа",
              "description": "Презентация, документ, схема или визуальное резюме."
            },
            {
              "title": "Продажи",
              "description": "Карточка товара, баннер или коммерческое предложение."
            },
            {
              "title": "Событие",
              "description": "Афиша, приглашение, программа или объявление."
            }
          ]
        },
        "audience": {
          "h2": "Кому подойдёт этот сценарий",
          "items": [
            {
              "label": "Кому",
              "body": "Пользователи, которые уже знают формат результата и хотят собрать новый макет."
            },
            {
              "label": "Когда особенно полезно",
              "body": "Пустой холст, неясная иерархия и попытка сразу украсить макет до определения сообщения."
            },
            {
              "label": "Подход",
              "body": "Создание конкретного макета: формат, сообщение, визуальная система, проверка и экспорт."
            }
          ]
        },
        "benefits": {
          "h2": "Почему такой порядок работает",
          "items": [
            {
              "title": "Формат задаёт правила",
              "description": "Размер и место публикации помогают принять композиционные решения."
            },
            {
              "title": "Сообщение остаётся главным",
              "description": "Декор поддерживает смысл, а не заменяет его."
            },
            {
              "title": "Система легко масштабируется",
              "description": "Цвет, типографика и изображения переносятся в связанные материалы."
            }
          ]
        },
        "limits": {
          "h2": "Что проверить перед началом",
          "body": "Доступность конкретных функций, режимов, лимитов и вариантов экспорта может меняться. Проверяйте актуальные условия в своём аккаунте и на официальном сайте Canva."
        },
        "related": {
          "h2": "Связанные задачи",
          "links": [
            {
              "route": "/nejroset-dlya-prezentacij/",
              "anchor": "Создайте презентацию из темы с помощью ИИ"
            },
            {
              "route": "/generator-izobrazhenij/",
              "anchor": "Генератор изображений по текстовому запросу"
            },
            {
              "route": "/redaktor-foto/",
              "anchor": "Редактируйте фото в одном рабочем пространстве"
            },
            {
              "route": "/obedinit-foto/",
              "anchor": "Объедините несколько фото в один дизайн"
            }
          ]
        },
        "faq": {
          "h2": "Частые вопросы",
          "items": [
            {
              "question": "С чего начать создание дизайна?",
              "answer": "С задачи, аудитории и формата. Затем определите главное сообщение и только после этого собирайте композицию."
            },
            {
              "question": "Как выбрать размер макета?",
              "answer": "Ориентируйтесь на место публикации или требования площадки. Готовые форматы помогают начать быстрее."
            },
            {
              "question": "Можно ли использовать собственные фото?",
              "answer": "Да, если текущий инструмент поддерживает загрузку. Проверяйте разрешение, права и качество исходников."
            },
            {
              "question": "Как понять, что макет не перегружен?",
              "answer": "На первом просмотре должны быть очевидны главный заголовок, визуальный акцент и следующий шаг."
            },
            {
              "question": "Чем эта страница отличается от главной?",
              "answer": "Главная помогает выбрать задачу, а эта страница ведёт через процесс создания конкретного нового макета."
            }
          ]
        },
        "finalCta": {
          "h2": "Перейдите к нужному результату",
          "description": "Выберите подходящий сценарий, проверьте исходные материалы и начните работу в Canva.",
          "primaryCta": "Попробовать бесплатно"
        }
      }
    },
    "images": [
      {
        "assetId": "sozdat-dizajn-visual-01",
        "section": "hero",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "одна идея в трёх форматах пост, афиша и слайд",
        "src": "/assets/generated/sozdat-dizajn-visual-01.webp"
      },
      {
        "assetId": "sozdat-dizajn-visual-02",
        "section": "product-proof",
        "action": "REPLACE_WITH_PRODUCT_UI",
        "purpose": "иерархия макета до и после упрощения",
        "src": null
      },
      {
        "assetId": "sozdat-dizajn-visual-03",
        "section": "examples",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "набор материалов в единой визуальной системе",
        "src": "/assets/generated/sozdat-dizajn-visual-03.webp"
      }
    ]
  },
  {
    "key": "udalit-fon",
    "route": "/udalit-fon/",
    "content": {
      "page": "/udalit-fon/",
      "meta": {
        "title": "Удалить фон с фото и сохранить объект",
        "description": "Как удалить фон с фото в Canva, проверить края и использовать прозрачный объект в карточке, презентации или другом дизайне.",
        "h1": "Удалите фон с фото и получите чистый объект",
        "ogTitle": "Удалить фон с фото и сохранить объект",
        "ogDescription": "Как удалить фон с фото в Canva, проверить края и использовать прозрачный объект в карточке, презентации или другом дизайне."
      },
      "sections": {
        "hero": {
          "eyebrow": "Практический сценарий",
          "h1": "Удалите фон с фото и получите чистый объект",
          "subtitle": "Отделите человека, товар или предмет от окружения и используйте результат в новом макете.",
          "primaryCta": "Попробовать бесплатно",
          "secondaryCta": ""
        },
        "capabilities": {
          "h2": "Что входит в этот сценарий",
          "cards": [
            {
              "id": "capability-1",
              "title": "Автоматическое выделение",
              "description": "Начните с распознавания главного объекта на снимке."
            },
            {
              "id": "capability-2",
              "title": "Проверка сложных краёв",
              "description": "Уделите внимание волосам, меху, стеклу и тонким деталям."
            },
            {
              "id": "capability-3",
              "title": "Прозрачный результат",
              "description": "Сохраните объект для использования на разных фонах."
            },
            {
              "id": "capability-4",
              "title": "Новая композиция",
              "description": "Переместите вырезанный объект в карточку, слайд или публикацию."
            },
            {
              "id": "capability-5",
              "title": "Финальная очистка",
              "description": "Проверьте ореолы исходного цвета и случайные фрагменты фона."
            }
          ]
        },
        "workflow": {
          "h2": "Как получить контролируемый результат",
          "steps": [
            {
              "index": 1,
              "title": "Выберите объект",
              "description": "Используйте снимок, где главный предмет хорошо отделяется от окружения."
            },
            {
              "index": 2,
              "title": "Удалите фон",
              "description": "Запустите инструмент и дождитесь выделения границ."
            },
            {
              "index": 3,
              "title": "Проверьте результат",
              "description": "Посмотрите объект на контрастных фонах и исправьте заметные края."
            }
          ]
        },
        "useCases": {
          "h2": "Для каких задач подходит",
          "items": [
            {
              "title": "Товар",
              "description": "Подготовить объект для каталога или маркетплейса."
            },
            {
              "title": "Портрет",
              "description": "Использовать человека в презентации или публикации."
            },
            {
              "title": "Предмет",
              "description": "Собрать коллаж из отдельных элементов."
            },
            {
              "title": "Логотип или знак",
              "description": "Удалить ровный фон, если права и качество исходника это позволяют."
            }
          ]
        },
        "audience": {
          "h2": "Кому подойдёт этот сценарий",
          "items": [
            {
              "label": "Кому",
              "body": "Пользователи, которым нужен вырезанный человек, товар или предмет для дальнейшего дизайна."
            },
            {
              "label": "Когда особенно полезно",
              "body": "Фон мешает композиции, а ручное выделение занимает время и повреждает тонкие края."
            },
            {
              "label": "Подход",
              "body": "Чистое отделение объекта с проверкой прозрачности и сложных границ."
            }
          ]
        },
        "benefits": {
          "h2": "Почему такой порядок работает",
          "items": [
            {
              "title": "Объект можно переиспользовать",
              "description": "Прозрачный результат подходит для нескольких композиций."
            },
            {
              "title": "Края проверяются в контексте",
              "description": "Контрастный фон быстро показывает ореолы и пропуски."
            },
            {
              "title": "Следующий шаг очевиден",
              "description": "После удаления можно заменить фон, собрать коллаж или создать дизайн."
            }
          ]
        },
        "limits": {
          "h2": "Что проверить перед началом",
          "body": "Доступность конкретных функций, режимов, лимитов и вариантов экспорта может меняться. Проверяйте актуальные условия в своём аккаунте и на официальном сайте Canva."
        },
        "related": {
          "h2": "Связанные задачи",
          "links": [
            {
              "route": "/zamenit-fon-na-foto/",
              "anchor": "Замените фон на фото, сохранив главный объект"
            },
            {
              "route": "/obedinit-foto/",
              "anchor": "Объедините несколько фото в один дизайн"
            },
            {
              "route": "/sozdat-dizajn/",
              "anchor": "Создайте дизайн под конкретный формат"
            }
          ]
        },
        "faq": {
          "h2": "Частые вопросы",
          "items": [
            {
              "question": "Как удалить фон с фотографии?",
              "answer": "Загрузите изображение, примените удаление фона и проверьте результат на контрастной подложке."
            },
            {
              "question": "Какой формат поддерживает прозрачность?",
              "answer": "Обычно для прозрачного фона используют PNG. Доступные варианты экспорта зависят от текущих условий Canva."
            },
            {
              "question": "Почему вокруг объекта остаётся контур?",
              "answer": "Это может быть цвет исходного фона или неточное выделение на полупрозрачных краях. Проверьте объект на светлой и тёмной подложке."
            },
            {
              "question": "Можно ли удалить фон у сложного объекта?",
              "answer": "Можно попробовать, но волосы, мех, стекло, дым и мелкая сетка требуют особенно внимательной проверки."
            },
            {
              "question": "Что делать после удаления фона?",
              "answer": "Поместите объект на новый фон, добавьте в презентацию, карточку товара, коллаж или другой макет."
            }
          ]
        },
        "finalCta": {
          "h2": "Перейдите к нужному результату",
          "description": "Выберите подходящий сценарий, проверьте исходные материалы и начните работу в Canva.",
          "primaryCta": "Попробовать бесплатно"
        }
      }
    },
    "images": [
      {
        "assetId": "udalit-fon-visual-01",
        "section": "hero",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "предмет на исходном и прозрачном фоне",
        "src": "/assets/generated/udalit-fon-visual-01.webp"
      },
      {
        "assetId": "udalit-fon-visual-02",
        "section": "product-proof",
        "action": "REPLACE_WITH_PRODUCT_UI",
        "purpose": "проверка тонких краёв на двух подложках",
        "src": null
      },
      {
        "assetId": "udalit-fon-visual-03",
        "section": "examples",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "вырезанный объект в трёх типах макета",
        "src": "/assets/generated/udalit-fon-visual-03.webp"
      }
    ]
  },
  {
    "key": "zamenit-fon-na-foto",
    "route": "/zamenit-fon-na-foto/",
    "content": {
      "page": "/zamenit-fon-na-foto/",
      "meta": {
        "title": "Заменить фон на фото, сохранив объект",
        "description": "Как заменить фон на фото в Canva: отделить объект, выбрать новое окружение, согласовать свет и проверить края.",
        "h1": "Замените фон на фото, сохранив главный объект",
        "ogTitle": "Заменить фон на фото, сохранив объект",
        "ogDescription": "Как заменить фон на фото в Canva: отделить объект, выбрать новое окружение, согласовать свет и проверить края."
      },
      "sections": {
        "hero": {
          "eyebrow": "Практический сценарий",
          "h1": "Замените фон на фото, сохранив главный объект",
          "subtitle": "Отделите объект от исходного окружения и подберите новый фон с подходящими светом и перспективой.",
          "primaryCta": "Попробовать бесплатно",
          "secondaryCta": ""
        },
        "capabilities": {
          "h2": "Что входит в этот сценарий",
          "cards": [
            {
              "id": "capability-1",
              "title": "Сохранить объект",
              "description": "Проверьте волосы, прозрачные детали и тонкие края после выделения."
            },
            {
              "id": "capability-2",
              "title": "Выбрать окружение",
              "description": "Используйте однотонный фон, интерьер или тематическую сцену."
            },
            {
              "id": "capability-3",
              "title": "Согласовать свет",
              "description": "Направление и жёсткость света должны совпадать с исходным объектом."
            },
            {
              "id": "capability-4",
              "title": "Вернуть естественную тень",
              "description": "Тень связывает объект с поверхностью и убирает эффект наклейки."
            },
            {
              "id": "capability-5",
              "title": "Подготовить формат",
              "description": "Адаптируйте композицию под карточку, портрет или публикацию."
            }
          ]
        },
        "workflow": {
          "h2": "Как получить контролируемый результат",
          "steps": [
            {
              "index": 1,
              "title": "Загрузите фото",
              "description": "Выберите снимок с различимым объектом и достаточным разрешением."
            },
            {
              "index": 2,
              "title": "Укажите новый фон",
              "description": "Опишите окружение или выберите подходящий визуальный материал."
            },
            {
              "index": 3,
              "title": "Проверьте склейку",
              "description": "Оцените края, цветовой баланс, масштаб, перспективу и тень."
            }
          ]
        },
        "useCases": {
          "h2": "Для каких задач подходит",
          "items": [
            {
              "title": "Карточка товара",
              "description": "Белый, нейтральный или контекстный фон."
            },
            {
              "title": "Деловой портрет",
              "description": "Спокойное окружение без отвлекающих деталей."
            },
            {
              "title": "Социальные сети",
              "description": "Новая сцена под сюжет публикации."
            },
            {
              "title": "Презентация",
              "description": "Фон, который поддерживает текст и не спорит с ним."
            }
          ]
        },
        "audience": {
          "h2": "Кому подойдёт этот сценарий",
          "items": [
            {
              "label": "Кому",
              "body": "Пользователи, которым нужно заменить неудачное окружение портрета, товара или предметной фотографии."
            },
            {
              "label": "Когда особенно полезно",
              "body": "Ручное выделение оставляет рваные края, а новый фон выглядит чужим из-за света и перспективы."
            },
            {
              "label": "Подход",
              "body": "Замена окружения с контролем краёв, масштаба, света и естественной тени."
            }
          ]
        },
        "benefits": {
          "h2": "Почему такой порядок работает",
          "items": [
            {
              "title": "Главный объект остаётся в центре задачи",
              "description": "Меняется окружение, а узнаваемые детали контролируются отдельно."
            },
            {
              "title": "Фон работает на сценарий",
              "description": "Окружение выбирается под продажу, рассказ или публикацию."
            },
            {
              "title": "Результат можно доработать",
              "description": "После замены доступны кадрирование, цвет и текстовые элементы."
            }
          ]
        },
        "limits": {
          "h2": "Что проверить перед началом",
          "body": "Доступность конкретных функций, режимов, лимитов и вариантов экспорта может меняться. Проверяйте актуальные условия в своём аккаунте и на официальном сайте Canva."
        },
        "related": {
          "h2": "Связанные задачи",
          "links": [
            {
              "route": "/udalit-fon/",
              "anchor": "Удалите фон с фото и получите чистый объект"
            },
            {
              "route": "/redaktor-foto/",
              "anchor": "Редактируйте фото в одном рабочем пространстве"
            },
            {
              "route": "/dobavit-udalit-obekt-na-foto/",
              "anchor": "Добавьте или удалите объект на фото"
            }
          ]
        },
        "faq": {
          "h2": "Частые вопросы",
          "items": [
            {
              "question": "Чем замена фона отличается от удаления фона?",
              "answer": "Удаление даёт объект без окружения, часто на прозрачном фоне. Замена сразу помещает объект в новую сцену."
            },
            {
              "question": "Какой исходник подходит лучше?",
              "answer": "Фото с чёткими границами объекта, достаточным контрастом и без сильного размытия по краям."
            },
            {
              "question": "Как сделать белый фон для товара?",
              "answer": "После отделения объекта выберите белую заливку и проверьте, чтобы края и тень выглядели естественно."
            },
            {
              "question": "Почему новый фон выглядит неестественно?",
              "answer": "Чаще всего не совпадают свет, перспектива, масштаб, цветовая температура или контактная тень."
            },
            {
              "question": "Можно ли использовать собственный фон?",
              "answer": "Такой сценарий зависит от доступных инструментов загрузки и редактирования в Canva. Проверьте их в аккаунте."
            }
          ]
        },
        "finalCta": {
          "h2": "Перейдите к нужному результату",
          "description": "Выберите подходящий сценарий, проверьте исходные материалы и начните работу в Canva.",
          "primaryCta": "Попробовать бесплатно"
        }
      }
    },
    "images": [
      {
        "assetId": "zamenit-fon-na-foto-visual-01",
        "section": "hero",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "тот же объект на нейтральном и интерьерном фоне",
        "src": "/assets/generated/zamenit-fon-na-foto-visual-01.webp"
      },
      {
        "assetId": "zamenit-fon-na-foto-visual-02",
        "section": "product-proof",
        "action": "REPLACE_WITH_PRODUCT_UI",
        "purpose": "крупный план сложного края волос",
        "src": null
      },
      {
        "assetId": "zamenit-fon-na-foto-visual-03",
        "section": "examples",
        "action": "REPLACE_WITH_GENERATED",
        "purpose": "согласование света и контактной тени",
        "src": "/assets/generated/zamenit-fon-na-foto-visual-03.webp"
      }
    ]
  }
]
